import { render, staticRenderFns } from "./VerifyTokenMail.vue?vue&type=template&id=7a8da6b6&scoped=true&"
import script from "./VerifyTokenMail.vue?vue&type=script&lang=js&"
export * from "./VerifyTokenMail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTokenMail.vue?vue&type=style&index=0&id=7a8da6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8da6b6",
  null
  
)

export default component.exports